/**
 * Balance refresh helper
 *
 * Refetches the authoritative balance from GET /api/user/balance and syncs
 * the auth store, so header coin/gem displays update after any spend
 * (prop purchases, entries, etc.).
 */

import { authFetch } from '@/lib/auth-client';
import { useAuthStore } from '@/stores/auth.store';

export async function refreshBalance(): Promise<void> {
  try {
    const res = await authFetch('/api/user/balance');
    if (!res.ok) return;
    const data = await res.json();
    useAuthStore.getState().updateBalance({
      coins: data.coins,
      gems: data.gems,
      // endpoint returns dollars; the store keeps cents
      usdBalanceCents: Math.round((data.usdBalance ?? 0) * 100),
    });
  } catch {
    // Non-fatal — the header keeps its previous value and syncs on the next
    // profile fetch.
  }
}
